import { FaAward } from "react-icons/fa6";
import { BiWorld } from "react-icons/bi";
import { BsTools } from "react-icons/bs";
import { ImHappy } from "react-icons/im";
import { FaEnvira } from "react-icons/fa";

export const GoalsList = [
  {
    goals: "Deliver Outstanding Quality",
    desc: "Consistently exceed customer expectations with exceptional workmanship and reliable services.",
    icon: <FaAward />
  },
  {
    goals: "Expand Service Reach",
    desc: "Grow our presence across the UAE and become the go-to choice for technical and maintenance services in diverse sectors.",
    icon: <BiWorld />
  },
  {
    goals: "Innovate with Technology",
    desc: "Embrace cutting-edge tools and techniques to provide smarter, more efficient solutions for our clients",
    icon: <BsTools />
  },
  {
    goals: "Ensure Customer Satisfaction",
    desc: "Build long-term relationships by providing personalized and timely services that prioritize client needs.",
    icon: <ImHappy />
  },
  {
    goals: "Promote Sustainability",
    desc: "Adopt eco-friendly practices and energy-efficient solutions that benefit both clients and the environment.",
    icon: <FaEnvira />
  }
];
